import { render, staticRenderFns } from "./Target2RemoveModal.vue?vue&type=template&id=66acc7ab"
import script from "./Target2RemoveModal.vue?vue&type=script&lang=js"
export * from "./Target2RemoveModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports